export default __webpack_public_path__ + "static/media/Mushrooms.01904eb3.png";